/**
 * @Author: v_jppjpeng
 * @Date: 2023-4-12 14:25:51
 * @Explain: 活动报表
 */

import { activityReportList } from '@/api/activityReport/data.d';
// router
import RouterPath from '@/router/routingPath';
// type
import { CommonOptionsType } from '@/definition/common/data.d';

export interface reportDependOnInfoType {
  /** 送达 */
  delivered: number;
}
export interface ActivityReportState {
  /** Report 动态指标信息 */
  dynamicIndexInfo: number;
  /** 报表详情信息 */
  reportDetailData?: activityReportList;
  /** 报表内计算、显示等依赖信息 */
  dependOnInfo: reportDependOnInfoType;
  /** ABtest活动 - 实验数据项 */
  abTestOpts: CommonOptionsType[];
}

export type ModelType = {
  namespace: string;
  state: ActivityReportState;
  reducers: {
    setDynamicIndexInfo: (
      state: ActivityReportState,
      action: { payload: any },
    ) => any;
    setReportDetailData: (
      state: ActivityReportState,
      action: { payload: any },
    ) => any;
    setDependOnInfo: (
      state: ActivityReportState,
      action: { payload: any },
    ) => any;
    setABTestOpts: (
      state: ActivityReportState,
      action: { payload: any },
    ) => any;
  };
  subscriptions: {
    setupHistory: ({ dispatch, history }: any) => any;
  };
};

const defaultReportDetailData = {
  /** 活动ID */
  taskId: 0,
  /** 活动名称 */
  name: '',
  /** 活动类型 1：常规活动 2：周期活动 */
  classification: 0,
  /** 当前是第几周期 */
  cycle: 0,
  /** 任务状态 */
  status: -1,
  /** 发送时间 */
  sendDate: '',
  /** 收件人 */
  recipient: 0,
  /** 送达 */
  delivered: 0,
  /** 打开 */
  opened: 0,
  /** 点击 */
  clicked: 0,
  /** 发送量 */
  sent: 0,
  /** 时区 */
  timeZone: 'UTF+00:00',
  /** 活动目的类型 */
  taskType: 0,
  /** 活动类型  1:常规活动  2:周期活动  3:ABTest活动 */
  qpsType: 0,
  /** 实验阶段 1-test in progress(实验中) 2-ongoing(剩余流量投递中) */
  expStage: 0,
  taskUuid: '',
  isExperiment: false,
  experimentList: [],
};

const defaultDependOnInfo = {
  /** 送达 */
  delivered: 0,
};
const ActivityReportModel: ModelType = {
  namespace: 'ActivityReportModel',
  state: {
    // Report 动态指标信息
    dynamicIndexInfo: 0,
    // 报表详情信息
    reportDetailData: {
      ...defaultReportDetailData,
    },
    // 报表内计算、显示等依赖信息
    dependOnInfo: { ...defaultDependOnInfo },
    /** ABtest活动 - 实验数据项 */
    abTestOpts: [],
  },
  reducers: {
    // 设置Report页面动态指标值
    setDynamicIndexInfo(state, action) {
      return {
        ...state,
        dynamicIndexInfo: action.payload,
      };
    },
    // 重置报表详情信息
    setReportDetailData(state, action) {
      return {
        ...state,
        reportDetailData: action.payload,
      };
    },
    // 设置报表内计算、显示等依赖信息
    setDependOnInfo(state, action) {
      return {
        ...state,
        dependOnInfo: {
          ...state.dependOnInfo,
          ...action.payload,
        },
      };
    },
    // 设置ABtest活动 - 实验数据项
    setABTestOpts(state, action) {
      return {
        ...state,
        abTestOpts: action.payload,
      };
    },
  },
  subscriptions: {
    setupHistory({ dispatch, history }) {
      return history.listen((localtion: any) => {
        let pathname = localtion?.location?.pathname;
        // 监听非报表详情页 还原信息
        if (pathname && pathname == RouterPath.ACTIVITY_REPORT) {
          dispatch({
            type: 'setReportDetailData',
            payload: { ...defaultReportDetailData },
          });
        }
      });
    },
  },
};

export default ActivityReportModel;
